import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllPaginationStates } from 'app/utils/helpers/pagination-storage';
import { clearAllPartiesPaginationStates } from 'app/utils/helpers/parties-pagination-storage';
import { consumePostLoginReturnPath } from 'data';
import type { User } from 'oidc-client-ts';

export const useAuthSigninCallback = (): ((user: User | undefined) => Promise<void>) => {
  const navigate = useNavigate();

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async (_user: User | undefined) => {
      clearAllPaginationStates();
      clearAllPartiesPaginationStates();
      const returnPath = consumePostLoginReturnPath();
      if (returnPath) {
        navigate(returnPath, { replace: true });
      } else {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    },
    [navigate],
  );
};
